import React from "react";
import { Wrapper, Image } from "./styled";
import Icon from "../../../../../images/delete.svg";

const DeleteIcon = (props) => {
  return (
    <Wrapper onClick={props.onClick} disabled={props.disabled}>
      <Image src={Icon} alt="icon" />
    </Wrapper>
  );
};

export default DeleteIcon;
